<script>
import icons from './../../helpers/icons';
import authService from "@/api/authService";
import router from "@/router";
import { SidebarMenu } from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import {decrypt} from "@/utils/crypto";

export default {
  name: 'DefaultNavLayout',
  components: {SidebarMenu},

  data() {
    return {
      sidebarWidth: '260px',
      collapsedWidth: '65px',
      organization: {},
      store: {},
      profile: {},
      subscription: {
        package: {}
      },
      accountsUrl: process.env.VUE_APP_ACCOUNTS_URL,
      avatarUrl: process.env.VUE_APP_API_IMAGE_URL + 'user/',
      orgLogoUrl: process.env.VUE_APP_API_IMAGE_URL + 'organization/',
      icons,
      // State of sidebar
      sidebarClosed: false,
      windowWidth: '',
    }
  },
  methods: {
    async logout() {
      await authService.userLogout()
    },
    myProfile () {
      router.push('/profile')
    },
    mainAccounts () {
      window.open(this.accountsUrl, '_self')
    },
    switchStore() {
      router.push('/select-store')
    },
    linkActive(paths) {
      let routeTo = this.$route.path.split('/', 2)[1]
      return paths.includes(routeTo)
    },
    toggleSidebar() {
      this.sidebarClosed = !this.sidebarClosed
    },
    resizeToggle() {
      this.sidebarClosed = window.innerWidth < 1000;
      this.collapsedWidth = window.innerWidth < 600 ? '0px' : '65px';
    },
  },

  computed: {
    menu() {
      const role = this.profile.role
      const isRegularUser = ['user', 'cashier', 'inventory'].includes(role)
      const isAdmin = ['primary', 'branch_manager', 'admin'].includes(role)
      const isSuperAdmin = role === 'super_admin'
      
      const orgLogo = {
        hiddenOnCollapse: true,
        attributes: {
          style: 'margin: 15px 0 15px 90px !important;' +
              'cursor: pointer;' +
              'background-image: url(' + this.orgLogo + ');' +
              'background-size: contain;' +
              'background-color: white;' +
              'background-repeat: no-repeat;' +
              'border-radius: 10px;' +
              'width: 40px;' +
              'height: 50px;',
          onclick: () => router.push('/'),
        },
      }

      const dashboard = {
        title: 'Dashboard',
        href: '/dashboard',
        icon: 'bi bi-house',
        active: ['dashboard'],
      }

      if (isRegularUser) {
        return [
          orgLogo,
          dashboard,
          {
            title: 'Point of Sale',
            href: '/pos',
            icon: 'bi bi-cart4',
            active: ['pos'],
          },
          {
            title: 'Products',
            icon: 'bi bi-box',
            isActive: (item) => this.linkActive(item.active),
            active: ['products', 'product', 'store-products'],
            child: [
              {
                title: 'View Products',
                href: '/products',
                icon: 'bi bi-list',
                class: 'ms-4',
              },
              {
                title: 'Stock Levels',
                href: '/store-products',
                icon: 'bi bi-card-checklist',
                class: 'ms-4',
              },
              {
                title: 'Store Orders',
                href: '/store-orders',
                icon: 'bi bi-list-task',
                class: 'ms-4',
              },
            ]
          },
          {
            title: 'Customers',
            icon: 'bi bi-people',
            isActive: (item) => this.linkActive(item.active),
            active: ['customers', 'customer', 'add-customer'],
            child: [
              {
                title: 'All Customers',
                href: '/customers',
                icon: 'bi bi-people',
                class: 'ms-4',
              },
              {
                title: 'Add Customer',
                href: '/add-customer',
                icon: 'bi bi-person-plus',
                class: 'ms-4',
              },
            ]
          },
          {
            title: 'My Sales',
            icon: 'bi bi-receipt',
            isActive: (item) => this.linkActive(item.active),
            active: ['store-sales', 'sale', 'returns', 'quotations', 'invoices'],
            child: [
              {
                title: 'Sales History',
                href: '/store-sales',
                icon: 'bi bi-clock-history',
                class: 'ms-4',
              },
              {
                title: 'Process Return',
                href: '/returns',
                icon: 'bi bi-arrow-return-left',
                class: 'ms-4',
              },
              {
                title: 'Quotations',
                href: '/quotations',
                icon: 'bi bi-blockquote-left',
                class: 'ms-4',
              },
              {
                title: 'Invoices',
                href: '/invoices',
                icon: 'bi bi-receipt-cutoff',
                class: 'ms-4',
              },
            ]
          },
        ]
      }

      if (isAdmin || isSuperAdmin) {
        const adminMenu = [
          orgLogo,
          dashboard,
          {
            title: 'Point of Sale',
            href: '/pos',
            icon: 'bi bi-cart4',
            active: ['pos'],
          },
          {
            title: 'Organization',
            icon: 'bi bi-building',
            isActive: (item) => this.linkActive(item.active),
            active: ['organization', 'stores', 'storefront'],
            child: [
              {
                title: 'Organization Info',
                href: '/organization',
                icon: 'bi bi-building-check',
                class: 'ms-4',
              },
              {
                title: 'Stores',
                href: '/stores',
                icon: 'bi bi-shop',
                class: 'ms-4',
              },
              {
                title: 'Online Storefront',
                href: '/storefront',
                icon: 'bi bi-shop-window',
                class: 'ms-4',
              },
            ],
          },
          {
            title: 'Inventory',
            icon: 'bi bi-box-seam',
            isActive: (item) => this.linkActive(item.active),
            active: [
                'products',
                'product',
                'add-product',
                'edit-product',
                'categories',
                'brands',
                'units',
                'store-products',
                'stock-take'
            ],
            child: [
              {
                title: 'Products',
                href: '/products',
                icon: 'bi bi-list',
                class: 'ms-4',
              },
              {
                title: 'Add Product',
                href: '/add-product',
                icon: 'bi bi-plus-lg',
                class: 'ms-4',
              },
              {
                title: 'Categories',
                href: '/categories',
                icon: 'bi bi-diagram-3',
                class: 'ms-4',
              },
              {
                title: 'Brands',
                href: '/brands',
                icon: 'bi bi-award',
                class: 'ms-4',
              },
              {
                title: 'Units',
                href: '/units',
                icon: 'bi bi-ui-checks-grid',
                class: 'ms-4',
              },
              {
                title: 'Stock Management',
                href: '/store-products',
                icon: 'bi bi-card-checklist',
                class: 'ms-4',
              },
              {
                title: 'Stock Take',
                href: '/stock-take',
                icon: 'bi bi-card-list',
                class: 'ms-4',
              },
              {
                title: 'Inter-Store Transfer',
                href: '/store-transfers',
                icon: 'bi bi-arrow-left-right',
                isActive: (item) => this.linkActive(item.active),
                active: ['store-transfers', 'store-transfer'],
                class: 'ms-4',
              },
              {
                title: 'Warehouse Transfer',
                href: '/transfers',
                icon: 'bi bi-box-arrow-right',
                class: 'ms-4',
              },
            ]
          },
          {
            title: 'Procurement',
            icon: 'bi bi-truck',
            isActive: (item) => this.linkActive(item.active),
            active: [
                'suppliers',
                'supplier',
                'purchases',
                'purchase',
                'orders',
                'order',
                'store-orders',
                'all-store-orders',
                'direct-purchases',
                'supplier-returns',
                'supplier-payments'
            ],
            child: [
              {
                title: 'Suppliers',
                href: '/suppliers',
                icon: 'bi bi-boxes',
                class: 'ms-4',
              },
              {
                title: 'Add Supplier',
                href: '/add-supplier',
                icon: 'bi bi-plus-lg',
                class: 'ms-4',
              },
              {
                title: 'Store Orders',
                href: '/store-orders',
                icon: 'bi bi-list-task',
                class: 'ms-4',
              },
              {
                title: 'All Store Orders',
                href: '/all-store-orders',
                icon: 'bi bi-card-list',
                class: 'ms-4',
              },
              {
                title: 'Supplier Orders',
                href: '/orders',
                icon: 'bi bi-cart',
                class: 'ms-4',
              },
              {
                title: 'Received Orders',
                href: '/purchases',
                icon: 'bi bi-cart-check',
                class: 'ms-4',
              },
              {
                title: 'Direct Purchases',
                href: '/direct-purchases',
                icon: 'bi bi-cart-plus',
                class: 'ms-4',
              },
              {
                title: 'Supplier Payments',
                href: '/supplier-payments',
                icon: 'bi bi-credit-card',
                class: 'ms-4',
              },
              {
                title: 'Supplier Returns',
                href: '/supplier-returns',
                icon: 'bi bi-arrow-return-left',
                isActive: (item) => this.linkActive(item.active),
                active: ['supplier-returns', 'supplier-return'],
                class: 'ms-4',
              },
            ]
          },
          {
            title: 'Sales & Revenue',
            icon: 'bi bi-cash-coin',
            isActive: (item) => this.linkActive(item.active),
            active: ['sales', 'sale', 'store-sales', 'returns', 'quotations', 'invoices'],
            child: [
              {
                title: 'All Sales',
                href: '/sales',
                icon: 'bi bi-cart-plus',
                class: 'ms-4',
              },
              {
                title: 'Store Sales',
                href: '/store-sales',
                icon: 'bi bi-shop',
                class: 'ms-4',
              },
              {
                title: 'Sales Returns',
                href: '/returns',
                icon: 'bi bi-arrow-return-left',
                class: 'ms-4',
              },
              {
                title: 'Invoices',
                href: '/invoices',
                icon: 'bi bi-receipt-cutoff',
                class: 'ms-4',
              },
              {
                title: 'Quotations',
                href: '/quotations',
                icon: 'bi bi-blockquote-left',
                class: 'ms-4',
              },
            ]
          },
          {
            title: 'Customers',
            icon: 'bi bi-people',
            isActive: (item) => this.linkActive(item.active),
            active: ['customers', 'customer', 'add-customer', 'edit-customer'],
            child: [
              {
                title: 'All Customers',
                href: '/customers',
                icon: 'bi bi-people',
                class: 'ms-4',
              },
              {
                title: 'Add Customer',
                href: '/add-customer',
                icon: 'bi bi-person-plus',
                class: 'ms-4',
              },
            ]
          },
          {
            title: 'Transactions',
            href: '/transactions',
            icon: 'bi bi-credit-card',
          },
          {
            title: 'Shifts',
            icon: 'bi bi-file-earmark-text',
            isActive: (item) => this.linkActive(item.active),
            active: ['shifts', 'shift'],
            child: [
              {
                title: 'All Shifts',
                href: '/shifts',
                icon: 'bi bi-clock-history',
                class: 'ms-4',
              },
            ]
          },
          {
            title: 'Reports & Analytics',
            icon: 'bi bi-bar-chart-line',
            isActive: (item) => this.linkActive(item.active),
            active: [
                'annual-report',
                'daily-report',
                'general-report',
                'stock-take-analytics',
                'product-sales-with-stock',
                'z-reports',
                'z-report',
                'monthly-product-sales',
                'top-selling-categories',
                'low-stock-products',
                'sales-trends',
                'revenue-by-payment-method',
                'product-performance'
            ],
            child: [
              {
                title: 'Annual Report',
                href: '/annual-report',
                icon: 'bi bi-graph-up-arrow',
                class: 'ms-4',
              },
              {
                title: 'Daily Report',
                href: '/daily-report',
                icon: 'bi bi-pie-chart',
                class: 'ms-4',
              },
              {
                title: 'General Report',
                href: '/general-report',
                icon: 'bi bi-clipboard2-data',
                class: 'ms-4',
              },
              {
                title: 'Stock Take Report',
                href: '/stock-take-analytics',
                icon: 'bi bi-clipboard-check',
                class: 'ms-4',
              },
              {
                title: 'Product Sales',
                href: '/product-sales-with-stock',
                icon: 'bi bi-bar-chart',
                class: 'ms-4',
              },
              {
                title: 'Z-Reports',
                href: '/z-reports',
                icon: 'bi bi-file-earmark-text',
                class: 'ms-4',
              },
              {
                title: 'Monthly Product Sales',
                href: '/monthly-product-sales',
                icon: 'bi bi-calendar-month',
                class: 'ms-4',
              },
              {
                title: 'Top Selling Categories',
                href: '/top-selling-categories',
                icon: 'bi bi-trophy',
                class: 'ms-4',
              },
              {
                title: 'Low Stock Products',
                href: '/low-stock-products',
                icon: 'bi bi-exclamation-triangle',
                class: 'ms-4',
              },
              {
                title: 'Sales Trends',
                href: '/sales-trends',
                icon: 'bi bi-graph-up',
                class: 'ms-4',
              },
              {
                title: 'Revenue by Payment',
                href: '/revenue-by-payment-method',
                icon: 'bi bi-credit-card-2-front',
                class: 'ms-4',
              },
              {
                title: 'Product Performance',
                href: '/product-performance',
                icon: 'bi bi-award',
                class: 'ms-4',
              },
            ],
          },
          {
            title: 'Settings',
            icon: 'bi bi-gear',
            isActive: (item) => this.linkActive(item.active),
            active: ['mpesa-integrations', 'settings', 'logs', 'users'],
            child: [
              {
                href: '/settings',
                title: 'System Settings',
                icon: 'bi bi-gear',
                class: 'ms-4',
              },
              {
                href: '/mpesa-integrations',
                title: 'Mpesa Integration',
                icon: 'bi bi-phone',
                class: 'ms-4',
              },
              {
                href: '/logs',
                title: 'System Logs',
                icon: 'bi bi-clock-history',
                class: 'ms-4',
              },
              {
                href: '/users',
                title: 'User Management',
                icon: 'bi bi-people',
                class: 'ms-4',
              },
            ],
          },
        ]

        if (isSuperAdmin) {
          const orgMenu = adminMenu.find(item => item.title === 'Organization')
          if (orgMenu) {
            orgMenu.active.push('organizations')
            orgMenu.child.push({
              title: 'All Organizations',
              href: '/organizations',
              icon: 'bi bi-buildings',
              class: 'ms-4',
            })
          }
        }

        return adminMenu
      }

      return [orgLogo, dashboard]
    },
    orgLogo() {
      return this.organization.logo !== null ?
          this.orgLogoUrl + this.organization.logo :
          'https://berilot.com/src/img/logos/logo.png'
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.resizeToggle);
    })
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.resizeToggle);
  },

  created: async function () {
    this.organization = JSON.parse(decrypt(sessionStorage.getItem('organization')))
    this.store = JSON.parse(decrypt(sessionStorage.getItem('store')))
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    this.subscription = JSON.parse(decrypt(sessionStorage.getItem('subscription')))
    this.resizeToggle()
  }
}
</script>

<template>
  <div class="main-container">
    <!-- Sidebar -->
    <sidebar-menu
        :menu="menu"
        hide-toggle
        style="background-color: #0d4072"
        :class="['sidebar', sidebarClosed?'closed':'']"
        :collapsed="sidebarClosed"
        :width="sidebarWidth"
        :widthCollapsed="collapsedWidth"
    >
    </sidebar-menu>
    <!-- /Sidebar -->

    <div :class="['app-container', {'sidebar-open':!sidebarClosed}]">
      <Navbar @sidebarToggle="toggleSidebar">
        <template v-slot:default="{toggleSidebar}">
          <div class="d-flex align-items-center w-100">
            <!--Hamburger menu-->
            <div @click="toggleSidebar" class="cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" class="stroke-default" width="30" height="30"
                   viewBox="0 0 24 24" stroke-width="1.5" fill="none" stroke-linecap="round"
                   stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z"/>
                <line x1="4" y1="6" x2="20" y2="6"/>
                <line x1="4" y1="12" x2="20" y2="12"/>
                <line x1="4" y1="18" x2="20" y2="18"/>
              </svg>
            </div>
            <!--Search field-->
            <div class="ms-5 d-none d-sm-block" style="width:500px;">
              <h4>{{ organization.name }} - {{ store.name }}</h4>
            </div>
            <div class="ms-auto d-flex flex-row justify-content-end align-items-center">
              <!--Notification bell-->
              <div class="cursor-pointer position-relative ms-4">
                <Dropdown size="md" menu-classes="dropdown-menu-sm"
                          :popper-config="{placement:'bottom-end'}">
                  <template #button>
                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-default" width="30"
                         height="30" viewBox="0 0 24 24" stroke-width="1.5" stroke="#4CAF50"
                         fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z"/>
                      <path
                          d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"/>
                      <path d="M9 17v1a3 3 0 0 0 6 0v-1"/>
                    </svg>
                    <!--Notification badge-->
                    <Badge pill class="font-size-50 position-absolute" style="top:0;right: 0;">
                    </Badge>
                  </template>
                  <!-- Dropdown content with multiple orders-->
<!--                  <div class="d-flex flex-row p-2 align-content-center justify-content-center" v-for="{name, title} in [-->
<!--                        {-->
<!--                            name: 'notification name',-->
<!--                            title: 'notification title'-->
<!--                        },-->
<!--                    ]">-->
<!--                    <div class="d-flex flex-column justify-content-center me-3">-->
<!--                    </div>-->
<!--                    <div>-->
<!--                      <div class="text-success font-size-100 fw-bold">{{ title }}</div>-->
<!--                      <div class="color-gray-500 font-size-75">{{ name }}</div>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="text-center p-2 font-size-75">
                    <a href="#" class=" color-gray-500">Mark all as read</a>
                  </div>
                </Dropdown>
              </div>
              <!--User avatar with dropdown -->
              <div class="ms-5">
                <Dropdown class="">
                  <template #button>
                    <div
                        class="d-flex flex-row align-items-center justify-content-center cursor-pointer">
                      <div class="me-3">
                        <div class="fw-bold">{{ profile.first_name }}</div>
                        <div class="font-size-75 color-gray-600">{{ profile.role }}</div>
                      </div>
                      <img style="max-width: 30px;" class="rounded-circle"
                           :src="avatarUrl + profile.avatar" alt="avatar">
                    </div>
                  </template>
                  <!-- Dropdown content -->
                  <div class="dropdown-item d-flex align-items-center p-2" @click="mainAccounts">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-house-gear" viewBox="0 0 16 16">
                      <path d="M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708z"/>
                      <path d="M11.886 9.46c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.044c-.613-.181-.613-1.049 0-1.23l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"/>
                    </svg>
                    <div class="ms-3 ">
                      Main Accounts
                    </div>
                  </div>
                  <div class="dropdown-item d-flex align-items-center p-2" @click="myProfile">
                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-default" width="20"
                         height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#4CAF50"
                         fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z"/>
                      <path
                          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    <div class="ms-3 ">
                      My Profile
                    </div>
                  </div>
                  <div class="dropdown-item d-flex align-items-center p-2" @click="switchStore">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21 9L9 9" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M15 15L3 15" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M18 12L20.913 9.08704V9.08704C20.961 9.03897 20.961 8.96103 20.913 8.91296V8.91296L18 6" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6 18L3.08704 15.087V15.087C3.03897 15.039 3.03897 14.961 3.08704 14.913V14.913L6 12" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    <div class="ms-3 ">
                      Switch Store
                    </div>
                  </div>
                  <div class="dropdown-item d-flex align-items-center p-2" @click="logout">
                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-default" width="20"
                         height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#4CAF50"
                         fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z"/>
                      <path
                          d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"/>
                      <path d="M7 12h14l-3 -3m0 6l3 -3"/>
                    </svg>
                    <div class="ms-3">
                      Logout
                    </div>
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>
        </template>
      </Navbar>
      <!-- Content with router view -->
      <div class="content-container container-fluid mt-4 mb-5">
        <div class="row">
          <div class="col">
            <router-view v-slot="{ Component }">
              <transition name="fade" mode="out-in">
                <keep-alive>
                  <component :is="Component" />
                </keep-alive>
              </transition>
            </router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-leave-to {
  opacity: 0;
}

.logo-text {
  background: linear-gradient(45deg, var(--bs-primary), var(--bs-secondary));
  background-clip: text;
  color: transparent;
}
.v-sidebar-menu .vsm--link_active {
  background-color: #2c78c1 !important;
}
.v-sidebar-menu .vsm--link_hover {
  background-color: #296eb1 !important;
}
.v-sidebar-menu .vsm--link_level-1.vsm--link_active{
  box-shadow: 4px 0 0 0 #ffffff inset !important;
}
.v-sidebar-menu .vsm--link_level-2.vsm--link_active{
  box-shadow: 4px 0 0 0 #ffffff inset !important;
}
.v-sidebar-menu .vsm--link_level-1 .vsm--icon{
  box-shadow: 1px 0 0 0 #ffffff inset !important;
}
</style>
